import { mainApi } from "services/main";
import {
  CreateAuditFormResponse,
  UploadUrlRequest,
  UploadUrlResponse,
  RegisterDocumentRequest,
  RegisterDocumentResponse,
} from "./definitions";
import { Audit } from "models/generateAuditSchemas";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createAudit: builder.mutation<CreateAuditFormResponse, Audit>({
      query: (request?: Audit) => ({
        url: "audit",
        body: request,
        method: "POST",
      }),
    }),
    uploadUrl: builder.mutation<UploadUrlResponse, UploadUrlRequest>({
      query: (request: UploadUrlRequest) => ({
        url: "file/upload-url",
        body: request,
        method: "POST",
      }),
    }),
    registerDocument: builder.mutation<
      RegisterDocumentResponse,
      RegisterDocumentRequest
    >({
      query: (request: RegisterDocumentRequest) => ({
        url: "documents",
        body: request,
        method: "POST",
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateAuditMutation,
  useUploadUrlMutation,
  useRegisterDocumentMutation,
} = extendedApi;
